var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3993 3.22298C14.5528 1.21686 17.4472 1.21687 18.6007 3.22299L31.4151 25.5089C32.5651 27.5089 31.1215 30.0043 28.8144 30.0043H3.18558C0.878532 30.0043 -0.565134 27.5089 0.584863 25.5089L13.3993 3.22298Z",
    fill: "#FFB266",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6719 25.0312C14.6719 24.2977 15.2665 23.7031 16 23.7031C16.7335 23.7031 17.3281 24.2977 17.3281 25.0312C17.3281 25.7648 16.7335 26.3594 16 26.3594C15.2665 26.3594 14.6719 25.7648 14.6719 25.0312Z",
    fill: "#FF7F00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6726 10.9997C14.6263 10.2108 15.3174 9.64062 16 9.64062C16.6826 9.64062 17.3737 10.2108 17.3274 10.9997L16.9765 20.4754C16.9727 20.7292 16.8703 20.9717 16.6906 21.1515C16.5074 21.3346 16.259 21.4375 16 21.4375C15.741 21.4375 15.4926 21.3346 15.3095 21.1515C15.1298 20.9717 15.0273 20.7292 15.0236 20.4754L14.6726 10.9997Z",
    fill: "#FF7F00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.4bc1c4d72b0a767ab388d39d897f690d.svg";
export { ForwardRef as ReactComponent };